import PublicApiForm from "../singleton/public-api-form";
import PublicApiCommon from "../singleton/public-api-common";

export default {

    Common: {

        processGdprResponse: PublicApiCommon.processGdprResponse.bind(PublicApiCommon),

        processQuestionResponse: PublicApiCommon.processQuestionResponse.bind(PublicApiCommon),

        processSenderVerification: PublicApiCommon.processSenderVerification.bind(PublicApiCommon),

        processIcs: PublicApiCommon.processIcs.bind(PublicApiCommon)

    },

    Form: {

        load: PublicApiForm.load.bind(PublicApiForm),

        submit: PublicApiForm.submit.bind(PublicApiForm)

    }

}